module.exports = __webpack_public_path__ + "static_pc/img/team5.f7806cb7.png";